function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.63262 11.2041L8.2687 15.9505C8.78938 15.9505 9.01488 15.7431 9.2853 15.4941L11.7264 13.3308L16.7847 16.7657C17.7124 17.2451 18.366 16.9926 18.6163 15.9743L21.9365 1.54819L21.9374 1.54734C22.2317 0.275743 21.4415 -0.221504 20.5377 0.0904442L1.02135 7.01876C-0.310594 7.49816 -0.290427 8.18665 0.794932 8.4986L5.78447 9.93764L17.3742 3.21333C17.9196 2.87843 18.4155 3.06373 18.0076 3.39863L8.63262 11.2041Z",
  fill: "currentColor"
});

var SvgTgShare = function SvgTgShare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTgShare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tg-share.a3540cd0.svg";
export { ForwardRef as ReactComponent };